import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './Editor.css';

const Editor = ({ value, onChange }) => {
  // Define custom color palette with brand colors first
  const colors = [
    // Brand Colors (prominently placed first)
    '#FB7E00', '#FFA700', '#000000', '#FFFFFF',
    // Additional complementary colors for brand
    '#e67100', '#ffb833', '#333333', '#f8f9fa',
    // Standard color palette
    '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff',
    '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
    '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
    '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
    '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466',
    '#2c2c2c', '#0d1117', '#f85149', '#da7633', '#dbab09', '#3fb950', '#58a6ff', '#a5a5f5',
    // Disabled gray for reference
    '#CCCCCC'
  ];

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': colors }, { 'background': colors }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['blockquote', 'code-block'],
      ['clean']
    ],
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
    'color', 'background',
    'script', 'direction', 'align',
    'code-block'
  ];

  return (
    <div className="editor-wrapper">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        preserveWhitespace
        placeholder="Unesite sadržaj blog posta..."
      />
    </div>
  );
};

export default Editor; 